import type { ReactElement, ReactNode } from "react";

import { PageHeading, Tabs } from "@prequel/shared-components";

import Breadcrumbs from "@/components/Breadcrumbs";

type DetailPageLayoutProps = {
  title: string;
  onGoBack: () => void;
  dynamicLabel?: string;
  subheading?: ReactNode;
  tabs?: ReactElement[];
  actions?: ReactNode;
  children: ReactNode;
};

const DetailPageLayout = ({
  title,
  onGoBack,
  dynamicLabel,
  subheading,
  tabs,
  actions,
  children,
}: DetailPageLayoutProps) => (
  <div className="max-w-4xl px-7 py-4">
    <PageHeading
      title={title}
      onGoBack={onGoBack}
      breadcrumbs={<Breadcrumbs dynamicLabel={dynamicLabel ?? title} />}
      subheading={subheading}
    >
      {actions}
    </PageHeading>
    <div className="flex-1">
      <div className="relative">
        <div className="pt-0 pb-16">
          {tabs ? (
            <div className="pb-6">
              <Tabs tabs={tabs} />
              {children}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  </div>
);

export default DetailPageLayout;
